<template>
  <div class="flex flex-row">
    <UnderlineSelect v-model="year">
      <template #selected>
        <div class="w-10 text-center">
          {{ year ? `${year}` : "&nbsp;" }}
        </div>
      </template>
      <template #options>
        <BaseSelectOption
          v-for="(num, index) in required ? [...range(1900, thisYear + 1).reverse()] : [undefined, ...range(1900, thisYear + 1).reverse()]"
          :key="index"
          :value="num"
          class="text-center"
        >
          {{ num ? `${num}` : "&nbsp;" }}
        </BaseSelectOption>
      </template>
    </UnderlineSelect>
    <div class="pt-1 pr-2">
      年
    </div>

    <UnderlineSelect v-model="month">
      <template #selected>
        <div class="w-6 text-center">
          {{ month ? `${month}` : "&nbsp;" }}
        </div>
      </template>
      <template #options>
        <BaseSelectOption
          v-for="(num, index) in required ? [...range(1, 13)] : [undefined, ...range(1, 13)]"
          :key="index"
          :value="num"
          class="text-center"
        >
          {{ num ? `${num}` : "&nbsp;" }}
        </BaseSelectOption>
      </template>
    </UnderlineSelect>
    <div class="pt-1 pr-2">
      月
    </div>

    <UnderlineSelect v-model="day">
      <template #selected>
        <div class="w-6 text-center">
          {{ day ? `${day}` : "&nbsp;" }}
        </div>
      </template>
      <template #options>
        <BaseSelectOption
          v-for="(num, index) in required ? [...range(1, 32)] : [undefined, ...range(1, 32)]"
          :key="index"
          :value="num"
          class="text-center"
        >
          {{ num ? `${num}` : "&nbsp;" }}
        </BaseSelectOption>
      </template>
    </UnderlineSelect>
    <div class="pt-1">
      日
    </div>
  </div>
</template>

<script lang="ts">
import dayjs from 'dayjs';
import range from 'lodash/range';
import { computed, defineComponent, PropType, toRefs } from 'vue';

import BaseSelectOption from '@/components/BaseSelectOption.vue';
import UnderlineSelect from '@/components/UnderlineSelect.vue';
import { Birthday } from '@/types/Birthday';

export default defineComponent({
  name: 'SurveyInputBirthday',
  components: {
    BaseSelectOption,
    UnderlineSelect,
  },
  props: {

    /**
     *  誕生日の日付
     */
    modelValue: {
      type: Object as PropType<Birthday>,
      default: () => ({}),
    },

    /**
     * 必須かどうか
     */
    required: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'update:modelValue',
  ],
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);

    const year = computed({
      get: () => modelValue.value?.year,
      set: (value: number | undefined) => emit('update:modelValue', {
        ...modelValue.value,
        year: value,
      }),
    });

    const month = computed({
      get: () => modelValue.value?.month,
      set: (value: number | undefined) => emit('update:modelValue', {
        ...modelValue.value,
        month: value,
      }),
    });

    const day = computed({
      get: () => modelValue.value?.day,
      set: (value: number | undefined) => emit('update:modelValue', {
        ...modelValue.value,
        day: value,
      }),
    });

    const thisYear = dayjs().year();

    return {
      year,
      month,
      day,
      range,
      thisYear,
    };
  },
});
</script>
